module.exports = __webpack_public_path__ + "img/favorites-list-empty-list-dark.7aa927fb.svg";